import React, {useEffect} from 'react';
import {styled} from '@mui/material/styles';
import {useDispatch} from "react-redux";
import {
    clearImage,
    setBlackURL,
    setFile,
    setImageStats,
    setOriginalImage,
    setOriginalStats,
    setStatsLoading,
    setStatsSet,
} from "../lib/slices/imageSlice";
import {Box} from "@mui/material";
import InputBase from "@mui/material/InputBase";
import grey from "@mui/material/colors/grey";
import PublishIcon from '@mui/icons-material/Publish';

// eslint-disable-next-line import/no-webpack-loader-syntax
import readWorker from 'workerize-loader!../workers/readImage.worker.js';


const StyledLabel = styled('label')(({theme, populated}) => ({
    cursor: 'pointer',
    display: 'flex',
    width: '100%',
    overflowX: 'hidden',
    backgroundColor: '#353535',
    textAlign: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(2),
    borderWidth: 3,
    borderColor: grey[800],
    borderStyle: 'solid',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: populated ? 12 : 24,
    transitionProperty: 'background-color border-color',
    transitionDuration: '0.25s',
    '&:hover': {
        backgroundColor: '#414141',
        borderColor: '#505050',
    },
}));


export default function InputSection() {

    const dispatch = useDispatch();

    const [inputFile, setInputFile] = React.useState(null);
    const [worker, setWorker] = React.useState(null);

    // Initialize worker
    useEffect(() => {
        if (!worker) {
            const workerInstance = readWorker();
            workerInstance.addEventListener('message', handleMessage);
            setWorker(workerInstance);
        }
    }, []);

    const handleReceivePercent = (e) => {
        console.log('percent', e.data.percent);
    }

    const handleReceiveStats = (data) => {
        dispatch(setImageStats(data));
        dispatch(setOriginalStats(data));
        dispatch(setStatsLoading(false));
        dispatch(setStatsSet(true));
    }

    const handleReceiveImage = (data) => {
        dispatch(setBlackURL(data));
    }

    const handleMessage = (e) => {
        switch (e.data.type) {
            case 'stats': handleReceiveStats(e.data.data); break;
            case 'imageData': handleReceiveImage(e.data.data); break;
            default: break;
        }
    }

    const callReadImage = (url) => {
        if (worker)
            worker.postMessage({
                type: 'readImageStats',
                options: {data: true},
                url: url,
            })
    };

    const readBlackPixels = (url) => {
        dispatch(setStatsLoading(true));
        callReadImage(url);
    };

    const handleFileChange = event => {
        if (event.target.files[0]) {
            try {
                let file = event.target.files[0];
                dispatch(setFile(file));
                const filename = `oledified_${file.name}_${new Date().toISOString()}`;
                const newURL = URL.createObjectURL(file);
                dispatch(setOriginalImage(newURL));
                setInputFile(event.target.files[0]);
                readBlackPixels(newURL);
            }
            catch(err) {
                console.error('Error loading image file', err);
                dispatch(setOriginalImage(undefined));
                dispatch(clearImage());
                setInputFile(null);
            }
        }
        else {
            dispatch(setOriginalImage(undefined));
            setInputFile(null);
            dispatch(clearImage());
        }
    };


    return (
        <Box sx={{p: 2}}>
            <InputBase
                sx={{display: 'none'}}
                id={'image'}
                type={'file'}
                onChange={handleFileChange}
                disabled={!worker}
                inputProps={{
                    accept: 'image/png, image/jpeg, image/webp',
                }}
            />
            <StyledLabel htmlFor={'image'} populated={inputFile !== null}>
                {inputFile === null ? <>
                    <PublishIcon sx={{width: 50, height: 50}}/><span>Load Image</span>
                </> : inputFile.name}
            </StyledLabel>
        </Box>
    );
}

